import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
    AangifteSchenkbelasting,
    APV, BokkzSbLogic,
    Effecten,
    GiftTaxEntity,
    IntermediaryEntity, NotarieleAkte,
    OmschrijvingEnBedrag,
    OndernemingSB,
    OnroerendeZaakSB, Persoon,
    PU,
    RoerendeZaak,
    Schenking,
    SchenkingOpPapier,
    SchenkingRelatieBegiftigdeMetSchenker,
    Vrijstellingen,
    Vruchtgebruik
} from '@snelstart-ventures/fiscaal/domain-logic';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {BokkzAlgDataService, BokkzSbDataService} from '@snelstart-ventures/fiscaal/domain-logic';
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {Subscription} from 'rxjs';
import {NgIf} from "@angular/common";
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-algemene-vragen',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        NgIf,
        SharedUiAlertModule
    ],
    templateUrl: './algemene-vragen.component.html',
    styleUrl: './algemene-vragen.component.css'
})
export class AlgemeneVragenComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    public intermediary = {} as IntermediaryEntity;
    private intermediaryEntitySubscription: Subscription | undefined;
    private giftTaxEntitySubscription: Subscription | undefined;
    public giftTaxEntity = {} as GiftTaxEntity;
    public sbAangifte = {} as AangifteSchenkbelasting;
    public schenkingFg = {} as FormGroup;
    public begiftigdeFg = {} as FormGroup;
    public objectFg = {} as FormGroup;
    public sbAangifteFg = {} as FormGroup;
    public focusedElementId: string | null = null;
    public year = {} as number;
    public beginDatum = new Date();
    public datumTeVroeg = false;
    public datumTeLaat = false;
    public datumOndertekeningTeVroeg = false
    public jaartalNietAkkkoord = false;

    public optionsOnherroepelijk: SelectFormControlItem<boolean>[] = [
        {value: false, label: 'Ja'},
        {value: true, label: 'Nee (herroepelijk)'},
    ];
    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        {value: true, label: 'Ja'},
        {value: false, label: 'Nee, eerdere schenking(en)'},
    ];
    public optionsWie: SelectFormControlItem<boolean>[] = [
        {value: false, label: 'De ontvanger'},
        {value: true, label: 'De schenker'},
    ];

    public optionsRelatie: SelectFormControlItem<string>[] = [
        {value: 'KIND', label: 'Kind'},
        {value: 'KLEINKIND', label: 'Kleinkind'},
        {value: 'PARTNER', label: 'Partner'},
        {value: 'SAMENWONEND', label: 'Samenwonend'},
        {value: 'EX_PARTNER', label: 'Ex-partner'},
        {value: 'STIEFKIND', label: 'Stiefkind'},
        {value: 'PLEEGKIND', label: 'Pleegkind'},
        {value: 'OVERIG', label: 'Overig'}
    ];

    public optionsSchenking: SelectFormControlItem<string>[] = [
        {value: 'CONTANTEN', label: 'Contanten'},
        {value: 'EFFECTEN', label: 'Effecten'},
        {value: 'VASTGOED', label: 'Onroerende zaak'},
        {value: 'ONDERNEMING', label: 'Onderneming'},
        {value: 'UITKERING', label: 'Periodieke uitkering'},
        {value: 'SCHENKING OP PAPIER', label: 'Schenking op papier'},
        {value: 'KWIJTSCHELDING', label: 'Kwijtschelding'},
        {value: 'ROERENDEZAAK', label: 'Roerende zaak'},
        {value: 'VRUCHTGEBRUIK', label: 'Vruchtgebruik'},
        {value: 'OVERIG', label: 'Overig'}
    ];

    constructor(
        public algDataService: BokkzAlgDataService,
        public dataService: BokkzSbDataService,
        public sbService: BokkzSbLogic,
        private fb: FormBuilder) {
        this.schenkingFg = this.fb.group<Schenking>({
            datumSchenking: null as unknown as Date,
            relatieBegiftigdeMetSchenker: null as unknown as SchenkingRelatieBegiftigdeMetSchenker,
            herroepelijkeSchenking: null as unknown as boolean,
            schenkerBetaaltDeSchenkbelasting: null as unknown as boolean,
            uitbreidingBegripSchenker: false,
            contanten: null as unknown as OmschrijvingEnBedrag,
            effecten: null as unknown as Effecten,
            onroerendeZaken: null as unknown as OnroerendeZaakSB,
            ondernemingen: null as unknown as OndernemingSB,
            apv: null as unknown as APV,
            periodiekeUitkering: null as unknown as PU,
            roerendeZaak: null as unknown as RoerendeZaak,
            schuldigerkenning: null as unknown as SchenkingOpPapier,
            kwijtscheldingSchuld: null as unknown as OmschrijvingEnBedrag,
            vruchtgebruik: null as unknown as Vruchtgebruik,
            overige: null as unknown as OmschrijvingEnBedrag,
            vrijstellingen: null as unknown as Vrijstellingen,
            notarieleAkte: null as unknown as NotarieleAkte,
            belastingBetaaldInAnderLand: null as unknown as number,
            landCodeBetaaldInAnderLand: null as unknown as string
        });
        this.objectFg = this.fb.group({
            objectSchenking: null as unknown as string
        });
        this.sbAangifteFg = this.fb.group({
            datumOndertekening: null as unknown as Date,
            plaatsOndertekening: null as unknown as string
        });
        this.begiftigdeFg = this.fb.group<Persoon>({
            roepnaam: null as unknown as string,
            voorletters: null as unknown as string,
            tussenvoegsels: null as unknown as string,
            achternaam: null as unknown as string,
            bsn: null as unknown as string,
            geboortedatum: null as unknown as Date,
            overlijdensdatum: null as unknown as Date,
            landCodeNationaliteit: null as unknown as string,
            indicatieEerdereSchenking: true
        });
    }

    ngOnInit(): void {
        this.intermediaryEntitySubscription = this.algDataService.intermediary.subscribe((value) => {
            this.intermediary = value;
        });
        this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((giftTaxEntity) => {
            this.giftTaxEntity = giftTaxEntity;
            if (giftTaxEntity.year) {
                this.year = giftTaxEntity.year;
            }
            const aangifte = giftTaxEntity.aangifte;
            if (aangifte) {
                this.sbAangifte = aangifte;
                this.sbAangifteFg.patchValue(aangifte, {emitEvent: false});
                this.begiftigdeFg.patchValue(aangifte?.aangever, {emitEvent: false});
                if (aangifte.schenking) {
                    this.schenkingFg.patchValue(aangifte.schenking[0], {emitEvent: false});
                    if (aangifte.schenking[0].contanten) {
                        this.objectFg.get('objectSchenking')?.setValue('CONTANTEN');
                    }
                    if (aangifte.schenking[0].effecten) {
                        this.objectFg.get('objectSchenking')?.setValue('EFFECTEN');
                    }
                    if (aangifte.schenking[0].onroerendeZaken) {
                        this.objectFg.get('objectSchenking')?.setValue('VASTGOED');
                    }
                    if (aangifte.schenking[0].ondernemingen) {
                        this.objectFg.get('objectSchenking')?.setValue('ONDERNEMING');
                    }
                    if (aangifte.schenking[0].periodiekeUitkering) {
                        this.objectFg.get('objectSchenking')?.setValue('UITKERING');
                    }
                    if (aangifte.schenking[0].schuldigerkenning) {
                        this.objectFg.get('objectSchenking')?.setValue('SCHENKING OP PAPIER');
                    }
                    if (aangifte.schenking[0].kwijtscheldingSchuld) {
                        this.objectFg.get('objectSchenking')?.setValue('KWIJTSCHELDING');
                    }
                    if (aangifte.schenking[0].roerendeZaak) {
                        this.objectFg.get('objectSchenking')?.setValue('ROERENDEZAAK');
                    }
                    if (aangifte.schenking[0].vruchtgebruik) {
                        this.objectFg.get('objectSchenking')?.setValue('VRUCHTGEBRUIK');
                    }
                    if (aangifte.schenking[0].overige) {
                        this.objectFg.get('objectSchenking')?.setValue('OVERIG');
                    }
                }
            }
        });
        this.setupDatumSchenkingWatcher();
        this.setupDatumOndertekeningWatcher();
        this.checkJaartalSchenking();
    }

    ngOnDestroy(): void {
        if (this.intermediaryEntitySubscription) {
            this.intermediaryEntitySubscription.unsubscribe();
        }
        if (this.giftTaxEntitySubscription) {
            this.giftTaxEntitySubscription.unsubscribe();
        }
    }

    saveForm(): void {
        this.dataService.soort.next(this.objectFg.getRawValue().objectSchenking);
        this.begiftigdeFg.updateValueAndValidity();
        this.schenkingFg.updateValueAndValidity();
        const schenking = this.schenkingFg.getRawValue();
        schenking.datumSchenking = this.schenkingFg.getRawValue().datumSchenking;
        schenking.herroepelijkeSchenking = this.schenkingFg.getRawValue().herroepelijkeSchenking;
        schenking.schenkerBetaaltDeSchenkbelasting = this.schenkingFg.getRawValue().schenkerBetaaltDeSchenkbelasting;
        schenking.relatieBegiftigdeMetSchenker = this.schenkingFg.getRawValue().relatieBegiftigdeMetSchenker;
        schenking.contanten = this.schenkingFg.getRawValue().contanten;
        schenking.uitbreidingBegripSchenker = false;
        this.giftTaxEntity.aangifte = {
            ...this.sbAangifte,
            datumOndertekening: this.sbAangifteFg.getRawValue().datumOndertekening,
            plaatsOndertekening: this.sbAangifteFg.getRawValue().plaatsOndertekening,
            begiftigde: {
                ...this.sbAangifte.begiftigde,
                indicatieEerdereSchenking: !this.begiftigdeFg.getRawValue().indicatieEerdereSchenking
            },
            schenking: [schenking]
        } as AangifteSchenkbelasting;
        this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
        this.setupDatumOndertekeningWatcher();
        this.setupDatumSchenkingWatcher();
        this.checkJaartalSchenking();
        setTimeout(() => {
            if (schenking.relatieBegiftigdeMetSchenker != undefined && schenking.datumSchenking != undefined && this.dataService.valide.value) {
                this.sbService.getCalculation();
            } else {
                this.sbService.getValidation()
            }
        }, 250);
    }

    get today(): Date {
        return new Date();
    }

    private setupDatumSchenkingWatcher(): void {
        const control = this.schenkingFg.get('datumSchenking');
        if (control) {
            this.checkDatumSchenking(control.value);
            control.valueChanges.subscribe(value => {
                this.checkDatumSchenking(value);
            });
        }
    }
    private checkDatumSchenking(value: string | Date): void {
        this.beginDatum = new Date(this.year, 1, 1)
        const datum = new Date(value);
        this.datumTeVroeg = datum < this.beginDatum;
        this.datumTeLaat = datum > this.today;
    }

    private setupDatumOndertekeningWatcher(): void {
        const control = this.sbAangifteFg.get('datumOndertekening');
        if (control) {
            this.checkDatumOndertekening();
            control.valueChanges.subscribe(() => {
                this.checkDatumOndertekening();
            });
        }
    }

    private checkDatumOndertekening(): void {
        const datumSchenking = this.schenkingFg.get('datumSchenking')?.value;
        const datumOndertekening = this.sbAangifteFg.get('datumOndertekening')?.value;

        if (datumSchenking && datumOndertekening) {
            const schenkingDate = new Date(datumSchenking);
            const ondertekeningDate = new Date(datumOndertekening);
            this.datumOndertekeningTeVroeg = ondertekeningDate < schenkingDate;
        } else {
            this.datumOndertekeningTeVroeg = false;
        }
    }

    private checkJaartalSchenking(): void {
        const datumSchenking = this.schenkingFg.get('datumSchenking')?.value;
        const datum = datumSchenking ? new Date(datumSchenking) : null;
        const jaartalDatumSchenking = datum?.getFullYear();

        if (jaartalDatumSchenking && this.year) {
            this.jaartalNietAkkkoord = jaartalDatumSchenking !== this.year
        } else {
            this.jaartalNietAkkkoord = false;
        }
    }




}
